import { Vertical } from '@sbt-web/adv';
import { useMemo } from 'react';
import { CategoryID } from '@sbt-web/network/types';
import { getVerticalOfCategoryID } from '@sbt-web/category-utils';

export const useGetVerticalByCategoryId = (id: CategoryID): Vertical =>
  useMemo(() => getVerticalOfCategoryID(id), [id]);
